export default __webpack_public_path__ + "static/media/checked_tab.e9ddafa6.svg";